interface BaseStateOpts {
  attributesObjRef?: any;
  attributesObj?: any;
  sortChoices: string[];
  defaultSortBy?: string[];
  defaultASC?: boolean[];
  searchAttributesArray?: string[];
  pageSizeIndex?: number;
  hasDefaultFilters?: boolean;
  dateMin?: any;
}

export default class BaseState<T> {
  readonly attributesObjRef: {
    data: any;
    isLoading: boolean;
  };

  readonly filters: {
    attributesObj: any;
    urlParamId: number;
    search: {
      $or: any;
      $and: any;
    };
    globalSearch: string;
    dateMin: any;
    dateMax: any;
    searchAttributesArray: string[];
  };

  readonly defaultFilters: {
    attributesObj: any;
    urlParamId: number;
    search: {
      $or: any;
      $and: any;
    };
    globalSearch: string;
    dateMin: any;
    dateMax: any;
    searchAttributesArray: string[];
  };

  readonly items: {
    isViewTable: boolean;
    isLoading: boolean;
    lastRefreshItemsDate: any;
    data: T[];
    error: any;
    request: any;
    queryParams: any;
    sort: { by: string[]; ASC: boolean[]; choices: string[] };
    page: number;
    pageSizeIndex: number;
    isEditMode: boolean;
    selectedItems: number[];
  };

  readonly current: {
    isLoading: boolean;
    data: T;
    error: any;
  };

  constructor({
    attributesObjRef = {},
    attributesObj = {},
    sortChoices = [],
    defaultSortBy,
    defaultASC = [false],
    pageSizeIndex = 0,
    searchAttributesArray = [],
    hasDefaultFilters = false,
    dateMin = null,
  }: BaseStateOpts) {
    this.attributesObjRef = {
      data: attributesObjRef,
      isLoading: false,
    };
    this.filters = {
      attributesObj,
      urlParamId: null,
      search: {
        $or: searchAttributesArray.reduce((ac, a) => ({ ...ac, [a]: '' }), {}),
        $and: {},
      },
      globalSearch: '',
      dateMin,
      dateMax: null,
      searchAttributesArray,
    };

    if (hasDefaultFilters) {
      this.defaultFilters = { ...this.filters };
    }

    this.items = {
      isViewTable: true,
      isLoading: false,
      lastRefreshItemsDate: null,
      data: [],
      error: null,
      request: null,
      queryParams: null,
      sort: {
        by:
          defaultSortBy || (sortChoices.length > 0 && sortChoices.slice(0, 1)),
        ASC: defaultASC,
        choices: sortChoices,
      },
      page: 1,
      pageSizeIndex,
      isEditMode: false,
      selectedItems: [],
    };
    this.current = {
      isLoading: false,
      data: null,
      error: null,
    };
  }
}
